// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GLfO","question":"styles_question__17gJG","description":"styles_description__1Bx3k"};